<template>
  <div class="commentMessage">
    <div class="commentMessage__header">
      <ul class="commentMessage__header__tab">
        <li class="commentMessage__header__title" @click="switchTab('receive_like', $event)">收到的赞</li>
        <li class="commentMessage__header__title" @click="switchTab('send_like', $event)">发出的赞</li>
        <span class="commentMessage__header__arrow" :style="`left:${arrow_offsetLeft}px`"></span>
      </ul>
    </div>
    <div class="commentMessage__items">
      <MessageItem v-for="(item, index) in data" :key="index" :dic="item" :username="username" :owner-info="userInfo" source="like"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MessageItem from "./MessageItem";
import { types as MessageTypes } from "@/store/modules/message";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "MoblieLikeMessage",
  components: {
    MessageItem
  },
  data() {
    return {
      fromType:'receive_like',
      arrow_offsetLeft:40,
    };;
  },
  computed: {
      ...mapState({
      username: state => state.login.username,
      userInfo: state => state.login.userInfo,
      page: state => state.message.page,
      load_more: state => state.message.load_more,
    }),
    ...mapGetters({
      data: MessageTypes.GETTER_LIST_MESSAGE
    })
  },

  methods: {
      ...mapMutations({}),
    ...mapActions({
      fetchData: MessageTypes.FETCH_LIST_MESSAGE,
      fetchDeleteEvent:MessageTypes.FETCH_DELETE_MESSAGE
    }),
    switchTab(fromType, e){
      this.arrow_offsetLeft = e.target.offsetLeft + 20;
      this.fromType = fromType;
      this.fetchData({page: 1, from:this.fromType})
    },

    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchData({page: that.page+1, from:that.fromType})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },

    //-----------MessageItem 的回调事件
    //删除事件
    deleteEvent(pk){
      this.fetchDeleteEvent(pk)
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let type = this.$route.query.type;
    if (type === "send") {
      this.fromType = "send_like";
    }
    this.fetchData({page: 1, from:this.fromType})
  }
};
</script>

<style scoped>
.commentMessage {
  width: 100%;
}
.commentMessage__header {
  width: 100%;
  /* height: 38px; */
  margin: 0 0 10px;
  box-shadow: -1px 0 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.04),
    1px 0 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  font-size: 12px;
  color: #333333;
}
.commentMessage__header__tab {
  width: 300px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.commentMessage__header__title {
  width: 142px;
  margin: 0 -2px 0 20px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  height: 38px;
  line-height: 38px;
  /* font-weight: bold; */
  font-size: 12px;
  cursor: pointer;
}
.commentMessage__header__arrow{
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -7px;
  left: 40px;
  background-color: #ff6600;
  background-color: #f2f2f5;
}
</style>
